export enum GroupMarkerColorsEnum {
    Red = 1,
    Green = 2,
    Blue = 4
};